{
  "batteryCharge": {
    "legendWithUnitLabel": "Carga de la batería interna ({{unitLabel}})"
  },
  "batteryGraph": {
    "legend": "Voltaje de entrada (V)"
  },
  "dailyVolumeWithUnitLabel": "Volumen diario (k{{unitLabel}})",
  "linkTo": "Analítica",
  "title": "Análisis de dispositivos",
  "waterUsage": {
    "graph": {
      "legend": "Volumen diario"
    }
  }
}
